import React from "react";
import {withStyles} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import {TableBody, TableContainer} from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import guid from "../../../../../../utils/guid";
import {displayDateTimeWithoutSecondsFormat} from "../../../../../../utils/staticData";
import PropTypes from 'prop-types';
import TableHeader from "../../../../../Common/TableHeader";
import t from "../../../../../../languages/pl";

const styles = theme => ({
    table: {
        marginTop: theme.spacing(5),
    }
});

const CustomCell = withStyles(theme => ({
    root: {
        textAlign: "center",
        height: 60,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    }
}))(props => <TableCell {...props}/>);

const LogTab = props => {
    const {classes, changes} = props;
    const headers = ["Operator", "Data wprowadzenia", "Rodzaj zmiany"];

    const printTable = (data) => {
        if (!Array.isArray(data) || data.length === 0)
            return (<TableRow>
                <TableCell
                    style={{textAlign: "center"}}
                    colSpan={3}
                >
                    {t.noDataInfo}
                </TableCell>
            </TableRow>);
        else {
            return (data.map(change => {
                    return (<TableRow key={guid()}>
                            <CustomCell>{change.operator}</CustomCell>
                            <CustomCell>
                                {moment.unix(change.data).format(displayDateTimeWithoutSecondsFormat)}
                            </CustomCell>
                            <CustomCell>{change.typ}</CustomCell>
                        </TableRow>
                    )
                })
            );
        }
    };

    return (
        <Paper className={classes.table}>
            <TableContainer>
                <Table stickyHeader>
                    <TableHeader data={headers}/>
                    <TableBody>
                        {printTable(changes)}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};
LogTab.propTypes = {
    classes: PropTypes.object,
    changes: PropTypes.array
};

export default withStyles(styles)(LogTab);
